"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.defaultState = exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _mapping = require("@nicbase/mapping");

var _classnames = _interopRequireDefault(require("classnames"));

var _nicbaseDialogs = require("nicbase-dialogs");

var _nicbaseForms = require("nicbase-forms");

var _nicbaseIcons = require("nicbase-icons");

var _nicbaseSecurity = require("nicbase-security");

var _nicbaseTranslation = require("nicbase-translation");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var defaultState = {
  NO_GPS: false,
  COUPLED: false,
  NOT_COUPLED: false,
  DRIVING: false,
  STANDING: false,
  LOADED: false,
  NOT_LOADED: false,
  DOOR_1_OPEN: false,
  DOOR_1_CLOSED: false,
  DOOR_1_NO_DATA: false,
  DOOR_2_OPEN: false,
  DOOR_2_CLOSED: false,
  DOOR_2_NO_DATA: false,
  DOOR_3_OPEN: false,
  DOOR_3_CLOSED: false,
  DOOR_3_NO_DATA: false,
  REEFER_ON: false,
  REEFER_OFF: false,
  NO_FUEL_RESERVE: false,
  FUEL_RESERVE: false,
  CARRIER_ALERT: false,
  CBT_ALERT: false,
  TK_ALERT: false,
  CARRIER_CAUTION: false,
  CBT_CAUTION: false,
  TK_CAUTION: false,
  CARRIER_NOTIFICATION: false,
  CBT_NOTIFICATION: false,
  TK_NOTIFICATION: false,
  CARRIER_INFORMATION: false,
  CBT_INFORMATION: false,
  TK_INFORMATION: false,
  DTC_ALARM: false,
  DTC_CAUTION: false,
  DTC_NOTIFICATION: false
};
exports.defaultState = defaultState;

var FilterDialogPresentation = function FilterDialogPresentation(_ref) {
  var selectedStatus = _ref.selectedStatus,
      onCancel = _ref.onCancel,
      onSave = _ref.onSave;
  var intl = (0, _nicbaseTranslation.useIntl)();

  var _usePermissions = (0, _nicbaseSecurity.usePermissions)('PORTAL'),
      hasPermissions = _usePermissions.hasPermissions;

  var _useState = (0, _react.useState)(Boolean(selectedStatus.NO_GPS)),
      _useState2 = _slicedToArray(_useState, 2),
      noGps = _useState2[0],
      setNoGps = _useState2[1];

  var _useState3 = (0, _react.useState)(Boolean(selectedStatus.COUPLED)),
      _useState4 = _slicedToArray(_useState3, 2),
      coupled = _useState4[0],
      setCoupled = _useState4[1];

  var _useState5 = (0, _react.useState)(Boolean(selectedStatus.NOT_COUPLED)),
      _useState6 = _slicedToArray(_useState5, 2),
      notCoupled = _useState6[0],
      setNotCoupled = _useState6[1];

  var _useState7 = (0, _react.useState)(Boolean(selectedStatus.DRIVING)),
      _useState8 = _slicedToArray(_useState7, 2),
      driving = _useState8[0],
      setDriving = _useState8[1];

  var _useState9 = (0, _react.useState)(Boolean(selectedStatus.STANDING)),
      _useState10 = _slicedToArray(_useState9, 2),
      standing = _useState10[0],
      setStanding = _useState10[1];

  var _useState11 = (0, _react.useState)(Boolean(selectedStatus.LOADED)),
      _useState12 = _slicedToArray(_useState11, 2),
      loaded = _useState12[0],
      setLoaded = _useState12[1];

  var _useState13 = (0, _react.useState)(Boolean(selectedStatus.NOT_LOADED)),
      _useState14 = _slicedToArray(_useState13, 2),
      notLoaded = _useState14[0],
      setNotLoaded = _useState14[1];

  var _useState15 = (0, _react.useState)(Boolean(selectedStatus.DOOR_1_OPEN)),
      _useState16 = _slicedToArray(_useState15, 2),
      door1Open = _useState16[0],
      setDoor1Open = _useState16[1];

  var _useState17 = (0, _react.useState)(Boolean(selectedStatus.DOOR_1_CLOSED)),
      _useState18 = _slicedToArray(_useState17, 2),
      door1Closed = _useState18[0],
      setDoor1Closed = _useState18[1];

  var _useState19 = (0, _react.useState)(Boolean(selectedStatus.DOOR_1_NO_DATA)),
      _useState20 = _slicedToArray(_useState19, 2),
      door1NoData = _useState20[0],
      setDoor1NoData = _useState20[1];

  var _useState21 = (0, _react.useState)(Boolean(selectedStatus.DOOR_2_OPEN)),
      _useState22 = _slicedToArray(_useState21, 2),
      door2Open = _useState22[0],
      setDoor2Open = _useState22[1];

  var _useState23 = (0, _react.useState)(Boolean(selectedStatus.DOOR_2_CLOSED)),
      _useState24 = _slicedToArray(_useState23, 2),
      door2Closed = _useState24[0],
      setDoor2Closed = _useState24[1];

  var _useState25 = (0, _react.useState)(Boolean(selectedStatus.DOOR_2_NO_DATA)),
      _useState26 = _slicedToArray(_useState25, 2),
      door2NoData = _useState26[0],
      setDoor2NoData = _useState26[1];

  var _useState27 = (0, _react.useState)(Boolean(selectedStatus.DOOR_3_OPEN)),
      _useState28 = _slicedToArray(_useState27, 2),
      door3Open = _useState28[0],
      setDoor3Open = _useState28[1];

  var _useState29 = (0, _react.useState)(Boolean(selectedStatus.DOOR_3_CLOSED)),
      _useState30 = _slicedToArray(_useState29, 2),
      door3Closed = _useState30[0],
      setDoor3Closed = _useState30[1];

  var _useState31 = (0, _react.useState)(Boolean(selectedStatus.DOOR_3_NO_DATA)),
      _useState32 = _slicedToArray(_useState31, 2),
      door3NoData = _useState32[0],
      setDoor3NoData = _useState32[1];

  var _useState33 = (0, _react.useState)(Boolean(selectedStatus.REEFER_ON)),
      _useState34 = _slicedToArray(_useState33, 2),
      reeferOn = _useState34[0],
      setReeferOn = _useState34[1];

  var _useState35 = (0, _react.useState)(Boolean(selectedStatus.REEFER_OFF)),
      _useState36 = _slicedToArray(_useState35, 2),
      reeferOff = _useState36[0],
      setReeferOff = _useState36[1];

  var _useState37 = (0, _react.useState)(Boolean(selectedStatus.NO_FUEL_RESERVE)),
      _useState38 = _slicedToArray(_useState37, 2),
      noFuelReserve = _useState38[0],
      setNoFuelReserve = _useState38[1];

  var _useState39 = (0, _react.useState)(Boolean(selectedStatus.FUEL_RESERVE)),
      _useState40 = _slicedToArray(_useState39, 2),
      fuelReserve = _useState40[0],
      setFuelReserve = _useState40[1];

  var _useState41 = (0, _react.useState)(Boolean(selectedStatus.CARRIER_ALERT)),
      _useState42 = _slicedToArray(_useState41, 2),
      carrierAlert = _useState42[0],
      setCarrierAlert = _useState42[1];

  var _useState43 = (0, _react.useState)(Boolean(selectedStatus.CBT_ALERT)),
      _useState44 = _slicedToArray(_useState43, 2),
      cbtAlert = _useState44[0],
      setCbtAlert = _useState44[1];

  var _useState45 = (0, _react.useState)(Boolean(selectedStatus.TK_ALERT)),
      _useState46 = _slicedToArray(_useState45, 2),
      tkAlert = _useState46[0],
      setTkAlert = _useState46[1];

  var _useState47 = (0, _react.useState)(Boolean(selectedStatus.CARRIER_CAUTION)),
      _useState48 = _slicedToArray(_useState47, 2),
      carrierCaution = _useState48[0],
      setCarrierCaution = _useState48[1];

  var _useState49 = (0, _react.useState)(Boolean(selectedStatus.CBT_CAUTION)),
      _useState50 = _slicedToArray(_useState49, 2),
      cbtCaution = _useState50[0],
      setCbtCaution = _useState50[1];

  var _useState51 = (0, _react.useState)(Boolean(selectedStatus.TK_CAUTION)),
      _useState52 = _slicedToArray(_useState51, 2),
      tkCaution = _useState52[0],
      setTkCaution = _useState52[1];

  var _useState53 = (0, _react.useState)(Boolean(selectedStatus.CARRIER_NOTIFICATION)),
      _useState54 = _slicedToArray(_useState53, 2),
      carrierNotification = _useState54[0],
      setCarrierNotification = _useState54[1];

  var _useState55 = (0, _react.useState)(Boolean(selectedStatus.CBT_NOTIFICATION)),
      _useState56 = _slicedToArray(_useState55, 2),
      cbtNotification = _useState56[0],
      setCbtNotification = _useState56[1];

  var _useState57 = (0, _react.useState)(Boolean(selectedStatus.TK_NOTIFICATION)),
      _useState58 = _slicedToArray(_useState57, 2),
      tkNotification = _useState58[0],
      setTkNotification = _useState58[1];

  var _useState59 = (0, _react.useState)(Boolean(selectedStatus.DTC_ALARM)),
      _useState60 = _slicedToArray(_useState59, 2),
      dtcAlarm = _useState60[0],
      setDtcAlarm = _useState60[1];

  var _useState61 = (0, _react.useState)(Boolean(selectedStatus.DTC_CAUTION)),
      _useState62 = _slicedToArray(_useState61, 2),
      dtcCaution = _useState62[0],
      setDtcCaution = _useState62[1];

  var _useState63 = (0, _react.useState)(Boolean(selectedStatus.DTC_NOTIFICATION)),
      _useState64 = _slicedToArray(_useState63, 2),
      dtcNotification = _useState64[0],
      setDtcNotification = _useState64[1];

  var handleSave = function handleSave() {
    onSave({
      NO_GPS: noGps,
      COUPLED: coupled,
      NOT_COUPLED: notCoupled,
      DRIVING: driving,
      STANDING: standing,
      LOADED: loaded,
      NOT_LOADED: notLoaded,
      DOOR_1_OPEN: door1Open,
      DOOR_1_CLOSED: door1Closed,
      DOOR_1_NO_DATA: door1NoData,
      DOOR_2_OPEN: door2Open,
      DOOR_2_CLOSED: door2Closed,
      DOOR_2_NO_DATA: door2NoData,
      DOOR_3_OPEN: door3Open,
      DOOR_3_CLOSED: door3Closed,
      DOOR_3_NO_DATA: door3NoData,
      REEFER_ON: reeferOn,
      REEFER_OFF: reeferOff,
      NO_FUEL_RESERVE: noFuelReserve,
      FUEL_RESERVE: fuelReserve,
      CARRIER_ALERT: carrierAlert,
      CBT_ALERT: cbtAlert,
      TK_ALERT: tkAlert,
      CARRIER_CAUTION: carrierCaution,
      CBT_CAUTION: cbtCaution,
      TK_CAUTION: tkCaution,
      CARRIER_NOTIFICATION: carrierNotification,
      CBT_NOTIFICATION: cbtNotification,
      TK_NOTIFICATION: tkNotification,
      CARRIER_INFORMATION: carrierNotification,
      CBT_INFORMATION: cbtNotification,
      TK_INFORMATION: tkNotification,
      DTC_ALARM: dtcAlarm,
      DTC_CAUTION: dtcCaution,
      DTC_NOTIFICATION: dtcNotification
    });
  };

  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_nicbaseDialogs.Dialog.Body, {
    className: "flex flex-col flex-1 text-sm"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex flex-col"
  }, /*#__PURE__*/_react["default"].createElement("h2", {
    className: "text-base font-bold py-3"
  }, intl.formatMessage({
    id: 'filters.misc'
  })), /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex items-center mb-1"
  }, /*#__PURE__*/_react["default"].createElement("span", {
    className: "flex-1"
  }, intl.formatMessage({
    id: 'filters.gps'
  })), /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
    id: (0, _mapping.statusToTranslation)('NO_GPS')
  }, function (message) {
    return /*#__PURE__*/_react["default"].createElement("span", {
      title: message,
      className: (0, _classnames["default"])('inline ml-1 cursor-pointer', {
        'shadow-status rounded-full': noGps
      }),
      onClick: function onClick() {
        return setNoGps(function (prev) {
          return !prev;
        });
      }
    }, /*#__PURE__*/_react["default"].createElement(_mapping.StatusIcon, {
      status: "NO_GPS",
      className: "w-6 h-6"
    }));
  })), hasPermissions(['module.filter.status.coupled']) && /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex items-center mb-1"
  }, /*#__PURE__*/_react["default"].createElement("span", {
    className: "flex-1"
  }, intl.formatMessage({
    id: 'filters.coupledState'
  })), /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
    id: (0, _mapping.statusToTranslation)('COUPLED')
  }, function (message) {
    return /*#__PURE__*/_react["default"].createElement("span", {
      title: message,
      className: (0, _classnames["default"])('inline ml-1 cursor-pointer', {
        'shadow-status rounded-full': coupled
      }),
      onClick: function onClick() {
        setCoupled(function (prev) {
          return !prev;
        });
        setNotCoupled(false);
      }
    }, /*#__PURE__*/_react["default"].createElement(_mapping.StatusIcon, {
      status: "COUPLED",
      className: "w-6 h-6"
    }));
  }), /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
    id: (0, _mapping.statusToTranslation)('NOT_COUPLED')
  }, function (message) {
    return /*#__PURE__*/_react["default"].createElement("span", {
      title: message,
      className: (0, _classnames["default"])('inline ml-1 cursor-pointer', {
        'shadow-status rounded-full': notCoupled
      }),
      onClick: function onClick() {
        setNotCoupled(function (prev) {
          return !prev;
        });
        setCoupled(false);
      }
    }, /*#__PURE__*/_react["default"].createElement(_mapping.StatusIcon, {
      status: "NOT_COUPLED",
      className: "w-6 h-6"
    }));
  })), /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex items-center mb-1"
  }, /*#__PURE__*/_react["default"].createElement("span", {
    className: "flex-1"
  }, intl.formatMessage({
    id: 'filters.movingState'
  })), /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
    id: (0, _mapping.statusToTranslation)('DRIVING')
  }, function (message) {
    return /*#__PURE__*/_react["default"].createElement("span", {
      title: message,
      className: (0, _classnames["default"])('inline ml-1 cursor-pointer', {
        'shadow-status rounded-full': driving
      }),
      onClick: function onClick() {
        setDriving(function (prev) {
          return !prev;
        });
        setStanding(false);
      }
    }, /*#__PURE__*/_react["default"].createElement(_nicbaseIcons.Driving, {
      status: "DRIVING",
      className: "w-6 h-6"
    }));
  }), /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
    id: (0, _mapping.statusToTranslation)('STANDING')
  }, function (message) {
    return /*#__PURE__*/_react["default"].createElement("span", {
      title: message,
      className: (0, _classnames["default"])('inline ml-1 cursor-pointer', {
        'shadow-status rounded-full': standing
      }),
      onClick: function onClick() {
        setStanding(function (prev) {
          return !prev;
        });
        setDriving(false);
      }
    }, /*#__PURE__*/_react["default"].createElement(_nicbaseIcons.Standing, {
      status: "STANDING",
      className: "w-6 h-6"
    }));
  })), /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex items-center mb-1"
  }, /*#__PURE__*/_react["default"].createElement("span", {
    className: "flex-1"
  }, intl.formatMessage({
    id: 'filters.ebsLoadCondition'
  })), /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
    id: (0, _mapping.statusToTranslation)('LOADED')
  }, function (message) {
    return /*#__PURE__*/_react["default"].createElement("span", {
      title: message,
      className: (0, _classnames["default"])('inline ml-1 cursor-pointer', {
        'shadow-status rounded-full': loaded
      }),
      onClick: function onClick() {
        setLoaded(function (prev) {
          return !prev;
        });
        setNotLoaded(false);
      }
    }, /*#__PURE__*/_react["default"].createElement(_mapping.StatusIcon, {
      status: "LOADED",
      className: "w-6 h-6"
    }));
  }), /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
    id: (0, _mapping.statusToTranslation)('NOT_LOADED')
  }, function (message) {
    return /*#__PURE__*/_react["default"].createElement("span", {
      title: message,
      className: (0, _classnames["default"])('inline ml-1 cursor-pointer', {
        'shadow-status rounded-full': notLoaded
      }),
      onClick: function onClick() {
        setNotLoaded(function (prev) {
          return !prev;
        });
        setLoaded(false);
      }
    }, /*#__PURE__*/_react["default"].createElement(_mapping.StatusIcon, {
      status: "NOT_LOADED",
      className: "w-6 h-6"
    }));
  }))), hasPermissions(['module.filter.status.door']) && /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex flex-col"
  }, /*#__PURE__*/_react["default"].createElement("h2", {
    className: "text-base font-bold py-3"
  }, intl.formatMessage({
    id: 'filters.doorStates'
  })), /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex items-center mb-1"
  }, /*#__PURE__*/_react["default"].createElement("span", {
    className: "flex-1"
  }, intl.formatMessage({
    id: 'filters.door'
  }, {
    number: 1
  })), /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
    id: (0, _mapping.statusToTranslation)('DOOR_1_OPEN')
  }, function (message) {
    return /*#__PURE__*/_react["default"].createElement("span", {
      title: message,
      className: (0, _classnames["default"])('inline ml-1 cursor-pointer', {
        'shadow-status rounded-full': door1Open
      }),
      onClick: function onClick() {
        setDoor1Open(function (prev) {
          return !prev;
        });
        setDoor1Closed(false);
        setDoor1NoData(false);
      }
    }, /*#__PURE__*/_react["default"].createElement(_mapping.StatusIcon, {
      status: "DOOR_1_OPEN",
      className: "w-6 h-6"
    }));
  }), /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
    id: (0, _mapping.statusToTranslation)('DOOR_1_CLOSED')
  }, function (message) {
    return /*#__PURE__*/_react["default"].createElement("span", {
      title: message,
      className: (0, _classnames["default"])('inline ml-1 cursor-pointer', {
        'shadow-status rounded-full': door1Closed
      }),
      onClick: function onClick() {
        setDoor1Closed(function (prev) {
          return !prev;
        });
        setDoor1Open(false);
        setDoor1NoData(false);
      }
    }, /*#__PURE__*/_react["default"].createElement(_mapping.StatusIcon, {
      status: "DOOR_1_CLOSED",
      className: "w-6 h-6"
    }));
  }), /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
    id: (0, _mapping.statusToTranslation)('DOOR_1_NO_DATA')
  }, function (message) {
    return /*#__PURE__*/_react["default"].createElement("span", {
      title: message,
      className: (0, _classnames["default"])('inline ml-1 cursor-pointer', {
        'shadow-status rounded-full': door1NoData
      }),
      onClick: function onClick() {
        setDoor1NoData(function (prev) {
          return !prev;
        });
        setDoor1Open(false);
        setDoor1Closed(false);
      }
    }, /*#__PURE__*/_react["default"].createElement(_mapping.StatusIcon, {
      status: "DOOR_1_NO_DATA",
      className: "w-6 h-6"
    }));
  })), /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex items-center mb-1"
  }, /*#__PURE__*/_react["default"].createElement("span", {
    className: "flex-1"
  }, intl.formatMessage({
    id: 'filters.door'
  }, {
    number: 2
  })), /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
    id: (0, _mapping.statusToTranslation)('DOOR_2_OPEN')
  }, function (message) {
    return /*#__PURE__*/_react["default"].createElement("span", {
      title: message,
      className: (0, _classnames["default"])('inline ml-1 cursor-pointer', {
        'shadow-status rounded-full': door2Open
      }),
      onClick: function onClick() {
        setDoor2Open(function (prev) {
          return !prev;
        });
        setDoor2Closed(false);
        setDoor2NoData(false);
      }
    }, /*#__PURE__*/_react["default"].createElement(_mapping.StatusIcon, {
      status: "DOOR_2_OPEN",
      className: "w-6 h-6"
    }));
  }), /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
    id: (0, _mapping.statusToTranslation)('DOOR_2_CLOSED')
  }, function (message) {
    return /*#__PURE__*/_react["default"].createElement("span", {
      title: message,
      className: (0, _classnames["default"])('inline ml-1 cursor-pointer', {
        'shadow-status rounded-full': door2Closed
      }),
      onClick: function onClick() {
        setDoor2Closed(function (prev) {
          return !prev;
        });
        setDoor2Open(false);
        setDoor2NoData(false);
      }
    }, /*#__PURE__*/_react["default"].createElement(_mapping.StatusIcon, {
      status: "DOOR_2_CLOSED",
      className: "w-6 h-6"
    }));
  }), /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
    id: (0, _mapping.statusToTranslation)('DOOR_2_NO_DATA')
  }, function (message) {
    return /*#__PURE__*/_react["default"].createElement("span", {
      title: message,
      className: (0, _classnames["default"])('inline ml-1 cursor-pointer', {
        'shadow-status rounded-full': door2NoData
      }),
      onClick: function onClick() {
        setDoor2NoData(function (prev) {
          return !prev;
        });
        setDoor2Open(false);
        setDoor2Closed(false);
      }
    }, /*#__PURE__*/_react["default"].createElement(_mapping.StatusIcon, {
      status: "DOOR_2_NO_DATA",
      className: "w-6 h-6"
    }));
  })), /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex items-center mb-1"
  }, /*#__PURE__*/_react["default"].createElement("span", {
    className: "flex-1"
  }, intl.formatMessage({
    id: 'filters.door'
  }, {
    number: 3
  })), /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
    id: (0, _mapping.statusToTranslation)('DOOR_3_OPEN')
  }, function (message) {
    return /*#__PURE__*/_react["default"].createElement("span", {
      title: message,
      className: (0, _classnames["default"])('inline ml-1 cursor-pointer', {
        'shadow-status rounded-full': door3Open
      }),
      onClick: function onClick() {
        setDoor3Open(function (prev) {
          return !prev;
        });
        setDoor3Closed(false);
        setDoor3NoData(false);
      }
    }, /*#__PURE__*/_react["default"].createElement(_mapping.StatusIcon, {
      status: "DOOR_3_OPEN",
      className: "w-6 h-6"
    }));
  }), /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
    id: (0, _mapping.statusToTranslation)('DOOR_3_CLOSED')
  }, function (message) {
    return /*#__PURE__*/_react["default"].createElement("span", {
      title: message,
      className: (0, _classnames["default"])('inline ml-1 cursor-pointer', {
        'shadow-status rounded-full': door3Closed
      }),
      onClick: function onClick() {
        setDoor3Closed(function (prev) {
          return !prev;
        });
        setDoor3Open(false);
        setDoor3NoData(false);
      }
    }, /*#__PURE__*/_react["default"].createElement(_mapping.StatusIcon, {
      status: "DOOR_3_CLOSED",
      className: "w-6 h-6"
    }));
  }), /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
    id: (0, _mapping.statusToTranslation)('DOOR_3_NO_DATA')
  }, function (message) {
    return /*#__PURE__*/_react["default"].createElement("span", {
      title: message,
      className: (0, _classnames["default"])('inline ml-1 cursor-pointer', {
        'shadow-status rounded-full': door3NoData
      }),
      onClick: function onClick() {
        setDoor3NoData(function (prev) {
          return !prev;
        });
        setDoor3Open(false);
        setDoor3Closed(false);
      }
    }, /*#__PURE__*/_react["default"].createElement(_mapping.StatusIcon, {
      status: "DOOR_3_NO_DATA",
      className: "w-6 h-6"
    }));
  }))), hasPermissions(['module.filter.status.reefer']) && /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex flex-col"
  }, /*#__PURE__*/_react["default"].createElement("h2", {
    className: "text-base font-bold py-3"
  }, intl.formatMessage({
    id: 'filters.reeferStates'
  })), /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex items-center mb-1"
  }, /*#__PURE__*/_react["default"].createElement("span", {
    className: "flex-1"
  }, intl.formatMessage({
    id: 'filters.reeferState'
  })), /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
    id: (0, _mapping.statusToTranslation)('REEFER_ON')
  }, function (message) {
    return /*#__PURE__*/_react["default"].createElement("span", {
      title: message,
      className: (0, _classnames["default"])('inline ml-1 cursor-pointer', {
        'shadow-status rounded-full': reeferOn
      }),
      onClick: function onClick() {
        setReeferOn(function (prev) {
          return !prev;
        });
        setReeferOff(false);
      }
    }, /*#__PURE__*/_react["default"].createElement(_mapping.StatusIcon, {
      status: "REEFER_ON",
      className: "w-6 h-6"
    }));
  }), /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
    id: (0, _mapping.statusToTranslation)('REEFER_OFF')
  }, function (message) {
    return /*#__PURE__*/_react["default"].createElement("span", {
      title: message,
      className: (0, _classnames["default"])('inline ml-1 cursor-pointer', {
        'shadow-status rounded-full': reeferOff
      }),
      onClick: function onClick() {
        setReeferOff(function (prev) {
          return !prev;
        });
        setReeferOn(false);
      }
    }, /*#__PURE__*/_react["default"].createElement(_mapping.StatusIcon, {
      status: "REEFER_OFF",
      className: "w-6 h-6"
    }));
  })), /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex items-center mb-1"
  }, /*#__PURE__*/_react["default"].createElement("span", {
    className: "flex-1"
  }, intl.formatMessage({
    id: 'filters.fuelState'
  })), /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
    id: (0, _mapping.statusToTranslation)('NO_FUEL_RESERVE')
  }, function (message) {
    return /*#__PURE__*/_react["default"].createElement("span", {
      title: message,
      className: (0, _classnames["default"])('inline ml-1 cursor-pointer', {
        'shadow-status rounded-full': noFuelReserve
      }),
      onClick: function onClick() {
        setNoFuelReserve(function (prev) {
          return !prev;
        });
        setFuelReserve(false);
      }
    }, /*#__PURE__*/_react["default"].createElement(_mapping.StatusIcon, {
      status: "NO_FUEL_RESERVE",
      className: "w-6 h-6"
    }));
  }), /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
    id: (0, _mapping.statusToTranslation)('FUEL_RESERVE')
  }, function (message) {
    return /*#__PURE__*/_react["default"].createElement("span", {
      title: message,
      className: (0, _classnames["default"])('inline ml-1 cursor-pointer', {
        'shadow-status rounded-full': fuelReserve
      }),
      onClick: function onClick() {
        setFuelReserve(function (prev) {
          return !prev;
        });
        setNoFuelReserve(false);
      }
    }, /*#__PURE__*/_react["default"].createElement(_mapping.StatusIcon, {
      status: "FUEL_RESERVE",
      className: "w-6 h-6"
    }));
  })), /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex items-center mb-1"
  }, /*#__PURE__*/_react["default"].createElement("span", {
    className: "flex-1"
  }, intl.formatMessage({
    id: 'filters.redErrorCodes'
  })), /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
    id: (0, _mapping.statusToTranslation)('CARRIER_ALERT')
  }, function (message) {
    return /*#__PURE__*/_react["default"].createElement("span", {
      title: message,
      className: (0, _classnames["default"])('inline ml-1 cursor-pointer', {
        'shadow-status rounded-full': carrierAlert
      }),
      onClick: function onClick() {
        return setCarrierAlert(function (prev) {
          return !prev;
        });
      }
    }, /*#__PURE__*/_react["default"].createElement(_mapping.StatusIcon, {
      status: "CARRIER_ALERT",
      className: "w-6 h-6"
    }));
  }), /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
    id: (0, _mapping.statusToTranslation)('CBT_ALERT')
  }, function (message) {
    return /*#__PURE__*/_react["default"].createElement("span", {
      title: message,
      className: (0, _classnames["default"])('inline ml-1 cursor-pointer', {
        'shadow-status rounded-full': cbtAlert
      }),
      onClick: function onClick() {
        return setCbtAlert(function (prev) {
          return !prev;
        });
      }
    }, /*#__PURE__*/_react["default"].createElement(_mapping.StatusIcon, {
      status: "CBT_ALERT",
      className: "w-6 h-6"
    }));
  }), /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
    id: (0, _mapping.statusToTranslation)('TK_ALERT')
  }, function (message) {
    return /*#__PURE__*/_react["default"].createElement("span", {
      title: message,
      className: (0, _classnames["default"])('inline ml-1 cursor-pointer', {
        'shadow-status rounded-full': tkAlert
      }),
      onClick: function onClick() {
        return setTkAlert(function (prev) {
          return !prev;
        });
      }
    }, /*#__PURE__*/_react["default"].createElement(_mapping.StatusIcon, {
      status: "TK_ALERT",
      className: "w-6 h-6"
    }));
  })), /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex items-center mb-1"
  }, /*#__PURE__*/_react["default"].createElement("span", {
    className: "flex-1"
  }, intl.formatMessage({
    id: 'filters.yellowErrorCodes'
  })), /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
    id: (0, _mapping.statusToTranslation)('CARRIER_CAUTION')
  }, function (message) {
    return /*#__PURE__*/_react["default"].createElement("span", {
      title: message,
      className: (0, _classnames["default"])('inline ml-1 cursor-pointer', {
        'shadow-status rounded-full': carrierCaution
      }),
      onClick: function onClick() {
        return setCarrierCaution(function (prev) {
          return !prev;
        });
      }
    }, /*#__PURE__*/_react["default"].createElement(_mapping.StatusIcon, {
      status: "CARRIER_CAUTION",
      className: "w-6 h-6"
    }));
  }), /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
    id: (0, _mapping.statusToTranslation)('CBT_CAUTION')
  }, function (message) {
    return /*#__PURE__*/_react["default"].createElement("span", {
      title: message,
      className: (0, _classnames["default"])('inline ml-1 cursor-pointer', {
        'shadow-status rounded-full': cbtCaution
      }),
      onClick: function onClick() {
        return setCbtCaution(function (prev) {
          return !prev;
        });
      }
    }, /*#__PURE__*/_react["default"].createElement(_mapping.StatusIcon, {
      status: "CBT_CAUTION",
      className: "w-6 h-6"
    }));
  }), /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
    id: (0, _mapping.statusToTranslation)('TK_CAUTION')
  }, function (message) {
    return /*#__PURE__*/_react["default"].createElement("span", {
      title: message,
      className: (0, _classnames["default"])('inline ml-1 cursor-pointer', {
        'shadow-status rounded-full': tkCaution
      }),
      onClick: function onClick() {
        return setTkCaution(function (prev) {
          return !prev;
        });
      }
    }, /*#__PURE__*/_react["default"].createElement(_mapping.StatusIcon, {
      status: "TK_CAUTION",
      className: "w-6 h-6"
    }));
  })), /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex items-center mb-1"
  }, /*#__PURE__*/_react["default"].createElement("span", {
    className: "flex-1"
  }, intl.formatMessage({
    id: 'filters.greenErrorCodes'
  })), /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
    id: (0, _mapping.statusToTranslation)('CARRIER_NOTIFICATION')
  }, function (message) {
    return /*#__PURE__*/_react["default"].createElement("span", {
      title: message,
      className: (0, _classnames["default"])('inline ml-1 cursor-pointer', {
        'shadow-status rounded-full': carrierNotification
      }),
      onClick: function onClick() {
        return setCarrierNotification(function (prev) {
          return !prev;
        });
      }
    }, /*#__PURE__*/_react["default"].createElement(_mapping.StatusIcon, {
      status: "CARRIER_NOTIFICATION",
      className: "w-6 h-6"
    }));
  }), /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
    id: (0, _mapping.statusToTranslation)('CBT_NOTIFICATION')
  }, function (message) {
    return /*#__PURE__*/_react["default"].createElement("span", {
      title: message,
      className: (0, _classnames["default"])('inline ml-1 cursor-pointer', {
        'shadow-status rounded-full': cbtNotification
      }),
      onClick: function onClick() {
        return setCbtNotification(function (prev) {
          return !prev;
        });
      }
    }, /*#__PURE__*/_react["default"].createElement(_mapping.StatusIcon, {
      status: "CBT_NOTIFICATION",
      className: "w-6 h-6"
    }));
  }), /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
    id: (0, _mapping.statusToTranslation)('TK_NOTIFICATION')
  }, function (message) {
    return /*#__PURE__*/_react["default"].createElement("span", {
      title: message,
      className: (0, _classnames["default"])('inline ml-1 cursor-pointer', {
        'shadow-status rounded-full': tkNotification
      }),
      onClick: function onClick() {
        return setTkNotification(function (prev) {
          return !prev;
        });
      }
    }, /*#__PURE__*/_react["default"].createElement(_mapping.StatusIcon, {
      status: "TK_NOTIFICATION",
      className: "w-6 h-6"
    }));
  }))), hasPermissions(['module.filter.status.ebs']) && /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex flex-col"
  }, /*#__PURE__*/_react["default"].createElement("h2", {
    className: "text-base font-bold py-3"
  }, intl.formatMessage({
    id: 'filters.ebsStates'
  })), /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex items-center mb-1"
  }, /*#__PURE__*/_react["default"].createElement("span", {
    className: "flex-1"
  }, intl.formatMessage({
    id: 'filters.ebsErrorCodes'
  })), /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
    id: "filters.DTC_ALARM"
  }, function (message) {
    return /*#__PURE__*/_react["default"].createElement("span", {
      title: message,
      className: (0, _classnames["default"])('inline ml-1 cursor-pointer', {
        'shadow-status rounded-full': dtcAlarm
      }),
      onClick: function onClick() {
        return setDtcAlarm(function (prev) {
          return !prev;
        });
      }
    }, /*#__PURE__*/_react["default"].createElement(_nicbaseIcons.DtcAlarm, {
      status: "DTC_ALARM",
      className: "w-6 h-6"
    }));
  }), /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
    id: "filters.DTC_CAUTION"
  }, function (message) {
    return /*#__PURE__*/_react["default"].createElement("span", {
      title: message,
      className: (0, _classnames["default"])('inline ml-1 cursor-pointer', {
        'shadow-status rounded-full': dtcCaution
      }),
      onClick: function onClick() {
        return setDtcCaution(function (prev) {
          return !prev;
        });
      }
    }, /*#__PURE__*/_react["default"].createElement(_nicbaseIcons.DtcCaution, {
      status: "DTC_CAUTION",
      className: "w-6 h-6"
    }));
  }), /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
    id: "filters.DTC_NOTIFICATION"
  }, function (message) {
    return /*#__PURE__*/_react["default"].createElement("span", {
      title: message,
      className: (0, _classnames["default"])('inline ml-1 cursor-pointer', {
        'shadow-status rounded-full': dtcNotification
      }),
      onClick: function onClick() {
        return setDtcNotification(function (prev) {
          return !prev;
        });
      }
    }, /*#__PURE__*/_react["default"].createElement(_nicbaseIcons.DtcNotification, {
      status: "DTC_NOTIFICATION",
      className: "w-6 h-6"
    }));
  })))), /*#__PURE__*/_react["default"].createElement(_nicbaseDialogs.Dialog.Footer, null, /*#__PURE__*/_react["default"].createElement(_nicbaseForms.Button, {
    primary: true,
    onClick: onCancel,
    className: "mr-1"
  }, /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
    id: "common.cancel"
  })), ",", /*#__PURE__*/_react["default"].createElement(_nicbaseForms.Button, {
    raised: true,
    primary: true,
    onClick: handleSave
  }, /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
    id: "common.save"
  }))));
};

FilterDialogPresentation.propTypes = {
  selectedStatus: _propTypes["default"].shape({
    NO_GPS: _propTypes["default"].bool,
    COUPLED: _propTypes["default"].bool,
    NOT_COUPLED: _propTypes["default"].bool,
    DRIVING: _propTypes["default"].bool,
    STANDING: _propTypes["default"].bool,
    LOADED: _propTypes["default"].bool,
    NOT_LOADED: _propTypes["default"].bool,
    DOOR_1_OPEN: _propTypes["default"].bool,
    DOOR_1_CLOSED: _propTypes["default"].bool,
    DOOR_1_NO_DATA: _propTypes["default"].bool,
    DOOR_2_OPEN: _propTypes["default"].bool,
    DOOR_2_CLOSED: _propTypes["default"].bool,
    DOOR_2_NO_DATA: _propTypes["default"].bool,
    DOOR_3_OPEN: _propTypes["default"].bool,
    DOOR_3_CLOSED: _propTypes["default"].bool,
    DOOR_3_NO_DATA: _propTypes["default"].bool,
    REEFER_ON: _propTypes["default"].bool,
    REEFER_OFF: _propTypes["default"].bool,
    NO_FUEL_RESERVE: _propTypes["default"].bool,
    FUEL_RESERVE: _propTypes["default"].bool,
    CARRIER_ALERT: _propTypes["default"].bool,
    CBT_ALERT: _propTypes["default"].bool,
    TK_ALERT: _propTypes["default"].bool,
    CARRIER_CAUTION: _propTypes["default"].bool,
    CBT_CAUTION: _propTypes["default"].bool,
    TK_CAUTION: _propTypes["default"].bool,
    CARRIER_NOTIFICATION: _propTypes["default"].bool,
    CBT_NOTIFICATION: _propTypes["default"].bool,
    TK_NOTIFICATION: _propTypes["default"].bool,
    CARRIER_INFORMATION: _propTypes["default"].bool,
    CBT_INFORMATION: _propTypes["default"].bool,
    TK_INFORMATION: _propTypes["default"].bool,
    DTC_ALARM: _propTypes["default"].bool,
    DTC_CAUTION: _propTypes["default"].bool,
    DTC_NOTIFICATION: _propTypes["default"].bool
  }),
  onCancel: _propTypes["default"].func,
  onSave: _propTypes["default"].func
};

var noop = function noop() {};

FilterDialogPresentation.defaultProps = {
  selectedStatus: {},
  onCancel: noop,
  onSave: noop
};
var _default = FilterDialogPresentation;
exports["default"] = _default;